import React, { useEffect, useState } from "react";
import PolicyGrid from "../customer-policy-grid/CustomerPolicyGrid";
import { PolicyTransactionsReadDto } from "../../../model/PolicyTransactionsReadDto";
import { CustomerPolicyDetailLabels as cstPolicyCoverageLabel } from '../../../../shared/util/label';
import { fomratWithCommasAndDecimals } from "../../../../shared/util/currencyUtils";
import { PolicySummaryErrorMessages } from "../../../../shared/util/constant";
import moment from "moment";
import "./CustomerPolicyTransactions.scss";
import { CommonUtility } from "../../../../Services/CommonUtility";

export interface ICustomerPolicyTransactions {
  policyTransactions: PolicyTransactionsReadDto[];
  onSelectTransaction: (columnValue: any) => void;
  onTranEffDateClick: (policyTransaction: PolicyTransactionsReadDto) => void
}

const CustomerPolicyTransactions: React.FunctionComponent<ICustomerPolicyTransactions> = (props) => {

  const dateFormat = "MM/DD/YYYY"

  const columns: any[] = [
    {
      Header: '',
      accessor: "polEventId",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>
    },
    {
      Header: cstPolicyCoverageLabel.SEQNUM,
      accessor: "seqNum",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>
    },
    {
      Header: cstPolicyCoverageLabel.TRANSACTION_EFFECTIVE_DATE,
      accessor: "tranEffDate",
      Cell: row => (
        <div>
          <a
            href="#"
            onClick={e => {
              e.preventDefault();
              props.onTranEffDateClick(row.row.original);
            }}
            className="tran-eff-date-link"
            title={row.value}
          >
            {row.value ? CommonUtility.formateDate(row.value, dateFormat) : null}
          </a>
        </div>
      ),
      width: 450,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.TRANSACTION_DESCRIPTION,
      accessor: "tranNote",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 500,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.TRANSACTION_TYPE,
      accessor: "tranType",
      Cell: row => <div><span title={row.value}>{row.value}</span></div>,
      width: 400,
      cellClassName: "",
      headerClassName: ""
    },
    {
      Header: cstPolicyCoverageLabel.Premium,
      accessor: "premium",
      Cell: row => <div><span style={{ color: row.value < 0 ? 'red' : 'black' }} title={row.value}>{fomratWithCommasAndDecimals(row.value)}</span></div>,
      width: 300,
      cellClassName: "right-align",
      headerClassName: "right-align-header"
    },
  ];

  const handleSelectedRow = (selected, columnValue) => {
    if (selected)
      props.onSelectTransaction(columnValue);
    else
      props.onSelectTransaction(null)

  };


  return (
    <PolicyGrid
      hiddenColumns={["seqNum", "polEventId"]}
      data={props.policyTransactions}
      columns={columns}
      gridId="policyTransactionsGrid"
      sortDefault={[{ id: "seqNum", desc: true }]}
      disableSorting={true}
      highlightColumn='seqNum'
      selectedColumn={handleSelectedRow}
      enableDefaultSelection={true}
      noRecordsMessage={PolicySummaryErrorMessages.NO_TRANSACTION_FOUND}
    />
  );
};

export default CustomerPolicyTransactions;
